import { selectSidebarOptionFromUrl } from "@/actions/common/sidebar-values";
import Url from 'url-parse';
import { WebsiteCookies } from "../common/website-cookies";
import { REDIRECT } from '@/imports-files/common/common';
import { SidebarService } from '@/services/components/sidebar-service';
import { ADMIN_SIDEBAR_OPTIONS, AGENCY_SIDEBAR_OPTIONS, SIDEBAR_OPTIONS } from "@/constants/components/sidebar";
export class SidebarAction
{
    constructor(router, t)
    {
      this.Options        =   null;
      this.router         =   router;
      this.website_cookie = new WebsiteCookies();
      this.t = t;
    }

    activateSidebarOption(element)
    {
      const current_element   =   element;
      const parent_element    =   current_element?.closest('.MainSidebar__Item');
      parent_element?.classList.add('Active');
    }

    activateSubsidebar(Options, key, navbarStatus, path)
    {
      var element = document.getElementById(key);
      if(Options['subSidebar_options']!=null && !this.subsidebarNotAllowedForUrls(navbarStatus, path))
      {
        this.deactiveAllSubsidebarOption();
        this.showSubsidebar();
        this.setActiveSidebarOptionColor(element);
        this.activateSubsidebarOption(navbarStatus);
      }
      else
      {
        this.hideSubsidebar();
        this.changeActiveSidebarOptionColor(element);
        this.deactiveAllSubsidebarOption();
      }
    }

    activateSubsidebarOption(navbarStatus)
    {
      let active_parent_element_name  =  navbarStatus.selectedParentSubSidebarOptions;
      let active_parent_element       =  document.querySelectorAll('[data-item-title="'+active_parent_element_name+'"]')[0];
      let active_element_name         =  navbarStatus.selectedSubSidebarOptions;
      let active_element              =  document.querySelectorAll('[data-item-title="'+active_element_name+'"]')[0];

      if(active_element !=  undefined)
      {
        if(active_parent_element != undefined)
        {
            if(active_parent_element.closest('.ParentSubSidebarItem'))
            {
              active_parent_element.closest('.ParentSubSidebarItem').classList.add('Open');
              active_parent_element.closest('.ParentSubSidebarItem').classList.remove('Close');
            }
        }

        if(active_element.closest('.ChildSubSidebarItem'))
        {
          active_element.closest('.ChildSubSidebarItem').parentElement.classList.add('Open');
          active_element.closest('.ChildSubSidebarItem').parentElement.classList.remove('Close');
          this.deactiveAllSelectedSubsidebarOption(active_element);
          active_element.classList.add('color-skyblue');
        }
      }
    }

    deactiveAllSidebarOption()
    {
      const all_sidebar_elements = document.getElementsByClassName('MainSidebar__Item');
      for ( var element of all_sidebar_elements)
      {
        element.classList.remove('Active');
      };
    }
    
    redirectToInboxPage(){
      let comm_page_url     =  REDIRECT.client.communication.inbox;
      let protocol       =  window.location.protocol;
      let host           =  window.location.host;
      let url            =  protocol + '//' + host + comm_page_url;
      window.open(url, '_self')
    }

    async handleSidebarIconClick(event, options, router, updateNavbarStatus, navbarStatus, setPageKey, setFlagForRerender)
    {
      // Note :- These line are here specially for the setting options rest of the other is manage by
      // the subsidebar handle router change function
      this.closeAllSubsidebarOptions();
      var link       =   options.link;
      // this.Options   =   options;
      // this.deactiveAllSidebarOption();
      // this.activateSidebarOption(event.currentTarget || event.target);
      var values     =  await selectSidebarOptionFromUrl(link);
      await updateNavbarStatus(values);
      // this.activateSubsidebar(this.Options, values.key, navbarStatus, link);
      if (link.includes('communication')) {
          this.redirectToInboxPage();  
          return
      } else if (!link.includes('settings')) {
          router.push(link);  
      }
      
      // setPageKey(values.key);
      setFlagForRerender(Math.random() * 10000);

    }

    showSubsidebar()
    {
      let SubSidebar = document.getElementsByClassName('SubSidebar')[0];
      let Sidebar    = document.getElementsByClassName('Sidebar')[0];

      if(SubSidebar != undefined && Sidebar != undefined)
      {
        Sidebar.classList.add('WithSubsidebar');
        SubSidebar.getElementsByClassName('SubSidebar__List')[0].classList.remove('Hidden');
        SubSidebar.classList.add('SubSidebar__Active');
        this.changeColorOfCurve('Open');
      }
    }

    hideSubsidebar()
    {
      let SubSidebar = document.getElementsByClassName('SubSidebar')[0];
      let Sidebar    = document.getElementsByClassName('Sidebar')[0];
      if(SubSidebar != undefined && Sidebar != undefined )
      {
        Sidebar.classList.remove('WithSubsidebar');
        SubSidebar.getElementsByClassName('SubSidebar__List')[0].classList.add('Hidden');
        SubSidebar.classList.remove('SubSidebar__Active');
        this.changeColorOfCurve('Close');
        // SubSidebar.style.display = 'none';
      }

    }

    setActiveSidebarOptionColor(element)
    {
      if(element != undefined)
      {
        const current_element = element;

        if(element.classList.contains('MainSidebar__Item'))
        {
          current_element.classList.add('Subsidebar');
        }
        else
        {
          const parent_element  = current_element.closest('.MainSidebar__Item');
          parent_element?.classList.add('Subsidebar');
        }
      }
    }

    deactiveAllSubsidebarOption()
    {
      var elements = Array.from(document.getElementsByClassName('SubSidebarItem'));
      elements.forEach((ele) => {
                                    ele.classList.remove('color-skyblue');
                                })

      var elements = Array.from(document.getElementsByClassName('SubSidebarItemText'));
      elements.forEach((ele) => {
                                    ele.classList.remove('color-skyblue');
                                })
    }

    closeAllSubsidebarOptions()
    {
      var elements = Array.from(document.getElementsByClassName('ParentSubSidebarItem'));
      elements.forEach((ele) => {
                                    ele.classList.remove('Open');
                                    ele.classList.add('Close');
                                })
    }

    deactiveAllSelectedSubsidebarOption(element)
    {
      var elements = Array.from(element.closest('.ChildSubSidebarItem').getElementsByClassName('SubSidebarItem'));
      elements.forEach((ele) => {
                                   ele.getElementsByClassName('SubSidebarItemText')[0].classList.remove('color-skyblue');
                                })
    }

    changeActiveSidebarOptionColor(element)
    {
      const current_element = element;
      const parent_element = current_element?.closest('.MainSidebar__Item');
      parent_element?.classList?.remove('Subsidebar');
    }

    // ------------------------- Subsidebar  -------------------------
    subsidebarChangeIcon(Options,completed_step_index)
    {
        var elements            =  Array.from(document.getElementsByClassName('SubSidebarItem'));
        // var current_step_index  = get_current_page_step(CLIENT_ONBOARDING_STEPS);
        var current_step_index  = get_current_page_step(Options);

        elements.forEach((element, index) =>
        {
            if( index < (completed_step_index) )
            {
                if(current_step_index == index)
                {
                  element.classList.remove('Completed');
                  element.classList.add('InProgress');
                }
                else
                {
                  element.classList.remove('InProgress');
                  element.classList.add('Completed');
                }

            }
            else if( index > (completed_step_index) )
            {
                element.classList.remove('InProgress');
                element.classList.remove('Completed');
            }
            else if( index == (completed_step_index) )
            {
              if(current_step_index == index)
              {
                element.classList.remove('InProgress');
                element.classList.remove('Completed');
                element.classList.add('InProgress');
              }
              else
              {
                element.classList.remove('InProgress');
              }
            }
      })
    }

    subsidebarQuickSetupChangeIcon(completed_steps, current_step)
    {
        var elements            =  Array.from(document.getElementsByClassName('SubSidebarItem'));

        elements.forEach((element, index) =>
        {
          completed_steps.forEach((complete_element) =>
          {
            if( element.getAttribute('data-item-title') == complete_element)
            {
                element.classList.remove('InProgress');
                element.classList.add('Completed');
            }

          })

          if(element.getAttribute('data-item-title') == current_step)
          {
            element.classList.remove('Completed');
            element.classList.add('InProgress');
          }
          else
          {
               element.classList.remove('InProgress');
          }

        })


    }


    subsidebarNotAllowedForUrls(navbarStatus, current_url)
    {
      if(navbarStatus.key != "settings")
      {
        var is_path_match = false;
        var hide_subsidebar = [
                                  /^\/clients\/jobs\?/,
                                  /^\/clients\/jobs$/,
                                  /^\/clients\/jobs\/.*\/kanban/,
                                  /^\/clients\/jobs\/.*\/kanban/,
                                  /^\/clients\/jobs\/.*\/applications\/.*\/candidate-profile-job\?/,
                                  /^\/admins\/clients\/client$/,
                                  /^\/admins\/clients\/client\?client_type=/,
                                  /^\/clients\/activities$/,
                                  /^\/clients\/activities\?/,
                                  /^\/clients\/jobs\/candidate\/.*\/merge-record\/duplicate-candidate\/.*/,
                                  /^\/clients\/jobs\/candidate\/.*\/merge-listing/,
                                  /^\/clients\/jobs\/offer-approval-listing$/,
                                  /^\/clients\/jobs\/offer-approval-listing\?/,
                                  /^\/clients\/jobs\/contract-listing$/,
                                  /^\/clients\/jobs\/contract-listing\?/,
                                  /^\/clients\/jobs\/.*\/offers\/.*\/approval-request-offer$/,
                                  /^\/clients\/jobs\/approval-request-job$/,
                                  /^\/clients\/jobs\/approval-listing/,
                                  /^\/clients\/jobs\/.*\/approval\/.*\/job-summary/
                              ]

        for( var element of hide_subsidebar)
        {
          if(current_url.match(element) != null )
          {
            is_path_match = true;
            break;
          }
        }
        return is_path_match
      }
      else
      {
        return false;
      }
    }
    // ------------------------- Subsidebar  -------------------------

    async getStoredStep(type)
    {
      // switch(type)
      // {
      //   case 'client-onboarding': var result = await AddUsers.getUserRoles();
      //                             break;
      //   case 'jobs':  'hello';
      //                 break;
      //   default: null;

      // }
    }

    handleClickOutside(event)
    {
        // var hamburgerMenu = document.getElementsByClassName('HamburgerMenu__List')[0];

        // if(hamburgerMenu.classList.contains('Open') && !event.target.parentElement.classList.contains('hamburger-menu'))
        // {
        //     hamburgerMenu.classList.remove('Open');
        //     hamburgerMenu.classList.add('Close');
        //     this.queryClient.setQueryData('hamburgerMenuStatus', ()=> {return "Close"})
        // }

    };

    changeColorOfCurve(subsidebar_status)
    {
      if(subsidebar_status == 'Open')
      {
        document.getElementsByClassName('TopRightCurve')[0].classList.add('WithSubSidebar');
        document.getElementsByClassName('BottomRightCurve')[0].classList.add('WithSubSidebar');
      }
      else
      {
        document.getElementsByClassName('TopRightCurve')[0].classList.remove('WithSubSidebar');
        document.getElementsByClassName('BottomRightCurve')[0].classList.remove('WithSubSidebar');
      }
    }

    handleLogout(dispatch, logoutUser)
    {
      const params = '';
      logoutUser(params, dispatch);
    }

    goToAdminDashboard(router)
    {
      let new_host   =  null;
      let subdomain  =  this.website_cookie.getCookie('subdomain');
      let host       =  Url(process.env.NEXT_PUBLIC_BASE_URL).host
      new_host       =  window.location.protocol + '//' + host;
      let url        =  `${new_host}${REDIRECT.admins.dashboard.activities}`;
      router.push(url);
    }

    getSidebarOptions(props)
    {
      let cookie_user_type = this.getUserTypeOnBaseOfCookies(props.session?.type)
      let user_type = '';
      if (this.router.pathname.startsWith('/admins'))
      {
        user_type = cookie_user_type || 'admin'
      }
      else if (this.router.pathname.startsWith('/clients')) {
        user_type = cookie_user_type == 'admin' ? 'client': (cookie_user_type || 'client');
      }
      else if (this.router.pathname.startsWith('/agency'))
      {
        user_type = cookie_user_type || 'agency';
      }

      
      switch (user_type)
      {

        case 'admin' : let admin_sidebar_options = ADMIN_SIDEBAR_OPTIONS(this.t)[0];
                       if(this.router.pathname.includes('clients/new'))
                       {
                          admin_sidebar_options.clients.subSidebar_options.company.link = REDIRECT.admins.dashboard.clients.company
                       }
                       return admin_sidebar_options;
        case 'agency': return AGENCY_SIDEBAR_OPTIONS(this.t)[0];
        default      : return SIDEBAR_OPTIONS(this.t)[0];
      }
    }

    setUserRole(session)
    {
      session.role = session?.role ;
      if (session?.role == 'Administrator' && this.router.pathname.startsWith('/clients')) {
        return 'account_owner'
      }
      else if (session.agency_user && this.router.pathname.startsWith('/agency'))
      {
        return session.agency_user_role == 'user' ? 'user' : 'admin'
      }
      else {
        return session?.role || this.website_cookie.getCookie('userType')
      }
    }

  getProfileRoutes() {
    if (this.router.pathname.startsWith('/admins')) {
      return REDIRECT.admins.dashboard.my_account;
    }
    else if (this.router.pathname.startsWith('/clients')) {
      return REDIRECT.client.settings.personal.my_account;
    }
    else if (this.router.pathname.startsWith('/agency')) {
      return REDIRECT.agency.dashboard.my_account;
    }
  }

  show_sidebar_options(OPTIONS, key, userRole, session)
  {
    let session_role = session?.role
    if(session_role)
    {
      return OPTIONS[key]['allowed_user_type'].includes(session_role)
    }
    else
    {
      return OPTIONS[key]['allowed_user_type'].includes(userRole)
    }
  }

  getUserTypeOnBaseOfCookies(type)
  {
    switch(type)
    {
      case 'Admin': return 'admin';
      case 'ClientUser': return 'client'
      case 'AgencyUser': return 'agency';
      default: 'client'
    }
  }

  async getProfilePhotoUrl(session){
    var sidebarService     =   new SidebarService();
    var result = await sidebarService.getProfilePhotoUrl();
    if(result.request.status == 200)
    {
      return result.data
    }
  }

  showImageOrInitials(isImage){
    if(isImage){
      let imageElement = document.querySelector('.AvatarImage')
      if(imageElement) imageElement.classList.remove('dnone');

      let initialElement = document.querySelector('.AvatarInitials')
      if(initialElement) initialElement.style.display = 'none'
    }
    else{
      let imageElement = document.querySelector('.AvatarImage')
      if(imageElement) imageElement.classList.add('dnone');

      let initialElement = document.querySelector('.AvatarInitials')
      if(initialElement) initialElement.style.display = 'flex'
    }
  }

}


function get_current_page_step(Options)
{
    var page_name_array = window.location.pathname.split('/');
    // var page_name = page_name_array[page_name_array.length ? page_name_array.length - 1 : 0 ];
    var page_name = page_name_array[0];
    return Options[page_name]
}


